import { useState, useEffect } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";

const useCurrentUser = () => {
  const axiosPrivate = useAxiosPrivate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axiosPrivate.get("/api/users/me");
        setUser(response.data);
      } catch (err) {
        console.error("Failed to fetch user", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  return { user, loading, error };
};

export default useCurrentUser;